<template>
  <b-badge :variant="`light-${variant}`" class="hb-status-badge">
    <slot>{{ label }}</slot>
  </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

/**
 * Badge de status por dominio.
 *
 * Os rotulos vem dos blocos de i18n que ja existem — nao duplica string. Os codigos sao
 * os do backend:
 *   participation  AP/AC/PU/RJ/LE/BL  (mkp.campaign_participations.status)
 *   withdrawal     SO/AP/AG/PR/PG/RJ/CA/FA  (fin.wallet_withdrawals.status)
 *   pix            PE/VA/RJ  (ppl.influencer_pix_keys.status)
 *
 * O variant `light-*` e o preenchimento tonal a 12% com a cor solida no texto, que e o
 * padrao de chip do app inteiro.
 */
const DOMAINS = {
  participation: {
    i18nPrefix: 'campaign.participation_status_',
    variants: { AC: 'success', AP: 'warning', PU: 'warning', RJ: 'danger', BL: 'danger', LE: 'secondary' },
  },
  withdrawal: {
    i18nPrefix: 'influencer_panel.withdrawal_status_',
    variants: {
      SO: 'warning', AP: 'info', AG: 'info', PR: 'info',
      PG: 'success', RJ: 'danger', FA: 'danger', CA: 'secondary',
    },
  },
  pix: {
    i18nPrefix: 'influencer_panel.pix_status_',
    variants: { VA: 'success', PE: 'warning', RJ: 'danger' },
  },
}

export default {
  name: 'HbStatusBadge',
  components: { BBadge },
  props: {
    status: { type: String, default: '' },
    domain: {
      type: String,
      required: true,
      validator: v => Object.keys(DOMAINS).includes(v),
    },
  },
  computed: {
    variant() {
      return DOMAINS[this.domain].variants[this.status] || 'secondary'
    },
    label() {
      return this.$t(`${DOMAINS[this.domain].i18nPrefix}.${this.status}`)
    },
  },
}
</script>

<style scoped>
.hb-status-badge {
  font-weight: var(--fw-medium);
}
</style>
